<div class="home-page-container">
  <div class="app-gutters list-page-gutters">    
    <div>
      <div>
        <ng-container>
          <dxo-card [bodyHeader]="selectStateBodyHeader">
            <card-body>
              <div class="state">
               <dxo-dropdown                  
                  data-e2e="StateDropdown"            
                  label="State"
                  (valueChange)="onFilterChange($any($event))"
                  [optionsObjects]="statesDropdown"
                >
                </dxo-dropdown>
              </div>          
            </card-body>
          </dxo-card>
        </ng-container>   
      </div>  
      <div class="loader-container" *ngIf="isLoading">
        <dxo-circular-loader text="Loading..." [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
      </div> 
      <div *ngIf="showCustomer">
        <ng-container>
          <dxo-card [bodyHeader]="customerBodyHeader">
            <card-body>
                <div>
                  <dxo-table
                    [stickyColumn]="false"
                    [data]="costomerDataTable"
                  ></dxo-table>
                </div>          
            </card-body>
          </dxo-card>
        </ng-container>
      </div>
      <div *ngIf="showClaims">
        <ng-container>
          <dxo-card [bodyHeader]="claimsBodyHeader">
            <card-body>
                <div>
                  <dxo-table
                    [data]="claimDataTable"
                  ></dxo-table>
                </div>          
            </card-body>
          </dxo-card>
        </ng-container>
      </div> 
    </div>
  </div>
</div>
